import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useCallback, useEffect } from 'react';
import PollManager from '../../services/poller/PollManager.js';
import { getErrorMessage } from '../Rssi/errorHandler.js';
import { useIntervalTrigged } from '../Rssi/useIntervalTrigged.js';
import { getTestStatusAsync, initiateVoiceTestAsync, allowedToDoVoiceTestAsync, testNeededAsync } from './VoiceTestSlice.js';

var VoiceTestState = {
  NOT_STARTED: 'NOT_STARTED',
  STARTED: 'STARTED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  TIMEOUT: 'TIMEOUT',
  ERROR: 'ERROR',
  NOT_READY: 'NOT_READY'
};

// TODO the maxTestTime does not seem to be respected?
var useVoiceTest = function useVoiceTest(client, giid, deviceLabel) {
  var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10000;
  var maxTestTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 150000;
  var voiceTestKey = 'voice_test_poll_key';
  var _useState = useState({
      state: VoiceTestState.NOT_STARTED,
      message: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    testState = _useState2[0],
    setTestState = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    sessionId = _useState6[0],
    setSessionId = _useState6[1];
  var testCompletedStates = ['SUCCESS', 'FAILED'];
  var _useIntervalTrigged = useIntervalTrigged(function () {
      setTestState({
        state: VoiceTestState.TIMEOUT,
        message: ''
      });
      stopTimeoutCountDown();
      PollManager.cancel(voiceTestKey);
    }, maxTestTime),
    startTimeoutCountDown = _useIntervalTrigged.start,
    stopTimeoutCountDown = _useIntervalTrigged.stop;
  var startPoll = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", PollManager.poll( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var _yield$getTestStatusA, state, sessionIdForMeasurement, testCompleted;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return getTestStatusAsync(client, giid, sessionId);
                    case 2:
                      _yield$getTestStatusA = _context.sent;
                      state = _yield$getTestStatusA.state;
                      sessionIdForMeasurement = _yield$getTestStatusA.sessionId;
                      if (!(sessionIdForMeasurement !== sessionId)) {
                        _context.next = 7;
                        break;
                      }
                      return _context.abrupt("return", false);
                    case 7:
                      if (state === 'SUCCESS') {
                        setTestState({
                          state: VoiceTestState.SUCCESS,
                          message: ''
                        });
                      } else if (state === 'FAILED') {
                        setTestState({
                          state: VoiceTestState.FAILED,
                          message: ''
                        });
                      }
                      testCompleted = testCompletedStates.includes(state);
                      if (testCompleted) {
                        stopTimeoutCountDown();
                      }
                      return _context.abrupt("return", testCompleted);
                    case 11:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })), {
              key: voiceTestKey,
              interval: interval,
              timeout: Infinity
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [deviceLabel, giid, sessionId]);
  useEffect(function () {
    if (sessionId) {
      setTestState({
        state: VoiceTestState.STARTED,
        message: ''
      });
      startTimeoutCountDown();
      startPoll();
    }
  }, [sessionId]);
  var startTest = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var pendingTests, voiceTestNeededOnDevice, _yield$allowedToDoVoi, voipAvailable, gsmVoiceAvailable, errorMessage, sId, _sId, _getErrorMessage, description;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return testNeededAsync(client, giid);
            case 3:
              pendingTests = _context3.sent;
              voiceTestNeededOnDevice = pendingTests.some(function (test) {
                return test.deviceLabel === deviceLabel && test.testType === 'VOICE_AUTO_TEST';
              });
              if (voiceTestNeededOnDevice) {
                _context3.next = 8;
                break;
              }
              setTestState({
                state: VoiceTestState.SUCCESS,
                message: ''
              });
              return _context3.abrupt("return");
            case 8:
              _context3.next = 10;
              return allowedToDoVoiceTestAsync(client, giid, deviceLabel);
            case 10:
              _yield$allowedToDoVoi = _context3.sent;
              voipAvailable = _yield$allowedToDoVoi.voipAvailable;
              gsmVoiceAvailable = _yield$allowedToDoVoi.gsmVoiceAvailable;
              errorMessage = _yield$allowedToDoVoi.errorMessage;
              if (!gsmVoiceAvailable) {
                _context3.next = 21;
                break;
              }
              _context3.next = 17;
              return initiateVoiceTestAsync(client, giid, deviceLabel, 'GSM');
            case 17:
              sId = _context3.sent;
              setSessionId(sId);
              _context3.next = 29;
              break;
            case 21:
              if (!voipAvailable) {
                _context3.next = 28;
                break;
              }
              _context3.next = 24;
              return initiateVoiceTestAsync(client, giid, deviceLabel, 'VOIP');
            case 24:
              _sId = _context3.sent;
              setSessionId(_sId);
              _context3.next = 29;
              break;
            case 28:
              setTestState({
                state: VoiceTestState.FAILED,
                message: errorMessage
              });
            case 29:
              _context3.next = 36;
              break;
            case 31:
              _context3.prev = 31;
              _context3.t0 = _context3["catch"](0);
              _getErrorMessage = getErrorMessage()(_context3.t0), description = _getErrorMessage.description;
              setError(description);
              if (_context3.t0.title === 'Installation already has an active autovoice session') {
                setTestState({
                  state: VoiceTestState.NOT_READY,
                  message: ''
                });
              } else {
                setTestState({
                  state: VoiceTestState.ERROR,
                  message: ''
                });
              }
            case 36:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 31]]);
    }));
    return function startTest() {
      return _ref3.apply(this, arguments);
    };
  }();
  var stopTest = function stopTest() {
    stopTimeoutCountDown();
    PollManager.cancel(voiceTestKey);
  };
  useEffect(function () {
    return function () {
      stopTest();
    };
  }, []);
  return {
    startTest: startTest,
    testState: testState,
    stopTest: stopTest,
    error: error
  };
};

export { VoiceTestState, useVoiceTest };
